import { useEffect, useState } from 'react';
import {
  dispatch,
  GenerateProductCatalogPDFRequest,
  getExtraDetails,
  getSelectedProducts,
  getWorkspaceId,
  SelectedTemplateType,
  updateSelectedTemplate,
  useAppSelector,
  useGenerateProductCatalogPDFMutation,
  useGenerateCustomerPricingProductPDFMutation,
} from '@zonofi/zono-money-store';

export const useSelectTemplate = () => {
  const workspaceId = useAppSelector(getWorkspaceId);
  const customerInfo = useAppSelector(getExtraDetails);
  const selectedProducts = useAppSelector(getSelectedProducts);

  const [generateGeneralProductPDF, generateGeneralProductPDFResponse] =
    useGenerateProductCatalogPDFMutation();
  const [generateCustomerProductPdf, generateCustomerProductPDFResponse] =
    useGenerateCustomerPricingProductPDFMutation();

  const [selectedTemplate, setSelectedTemplate] =
    useState<SelectedTemplateType>(SelectedTemplateType.PRODUCT_CATALOGUE);
  const [showPDFDrawer, setShowPDFDrawer] = useState<boolean>(false);
  const [generatedPDF, setGeneratedPDF] = useState<string | null>(null);

  const handleSelectTemplate = (template: SelectedTemplateType) => {
    dispatch(updateSelectedTemplate(template));
    setSelectedTemplate(template);
  };

  const handleGeneratePDF = () => {
    setShowPDFDrawer(true);

    const productVariantIds = selectedProducts.map((product) =>
      product?.productVariantId?.toString()
    );
    const basePayload = {
      params: {
        sellerWorkspaceId: workspaceId,
      },
      body: {
        templateName:
          selectedTemplate || SelectedTemplateType.PARENT_PRODUCT_CATALOGUE,
        productVariantIds,
      },
    };

    if (customerInfo?.customerId) {
      generateCustomerProductPdf({
        ...basePayload,
        body: {
          ...basePayload.body,
          customerId: customerInfo.customerId,
        },
      });
    } else {
      generateGeneralProductPDF(
        basePayload as GenerateProductCatalogPDFRequest
      );
    }
  };

  useEffect(() => {
    if (
      generateGeneralProductPDFResponse?.isSuccess &&
      generateGeneralProductPDFResponse?.data
    ) {
      setGeneratedPDF(generateGeneralProductPDFResponse.data);
    } else if (
      generateCustomerProductPDFResponse?.isSuccess &&
      generateCustomerProductPDFResponse?.data
    ) {
      setGeneratedPDF(generateCustomerProductPDFResponse.data);
    }
  }, [generateGeneralProductPDFResponse, generateCustomerProductPDFResponse]);

  return {
    selectedTemplate,
    handleSelectTemplate,
    onGeneratePDF: handleGeneratePDF,
    showPDFDrawer,
    setShowPDFDrawer,
    generatedPDF,
    setGeneratedPDF,
    generatePDFResponse: customerInfo?.customerId
      ? generateCustomerProductPDFResponse
      : generateGeneralProductPDFResponse,
  };
};
